import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Products from "@/components/site/Products";
import Capabilities from "@/components/site/Capabilities";
import WhyUs from "@/components/site/WhyUs";
import About from "@/components/site/About";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import EnquiryForm from "@/components/site/EnquiryForm";
import Footer from "@/components/site/Footer";
import FloatingCTA from "@/components/site/FloatingCTA";

export default function PublicSite() {
  const [content, setContent] = useState(null);
  const [failed, setFailed] = useState(false);
  const [productInterest, setProductInterest] = useState("");

  const scrollToEnquiry = useCallback((productId) => {
    if (productId) setProductInterest(productId);
    document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => setFailed(true));
  }, []);

  useEffect(() => {
    if (!content?.seo) return;
    document.title = content.seo.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", content.seo.description);
    const ld = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "AZ Concepts UK Ltd",
      url: "https://azconcepts.net",
      email: content.contact.email,
      telephone: content.contact.phone,
      address: content.contact.address,
    };
    let s = document.getElementById("org-jsonld");
    if (!s) {
      s = document.createElement("script");
      s.id = "org-jsonld";
      s.type = "application/ld+json";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(ld);
  }, [content]);

  if (failed)
    return (
      <div className="min-h-screen bg-[#0D0F12] text-slate-300 flex items-center justify-center font-body" data-testid="site-load-error">
        Unable to load the site right now. Please refresh.
      </div>
    );

  if (!content)
    return (
      <div className="min-h-screen bg-[#0D0F12] flex items-center justify-center" data-testid="site-loading">
        <div className="h-10 w-10 rounded-full border-2 border-[#FF5A1F] border-t-transparent animate-spin" />
      </div>
    );

  return (
    <div id="top" className="bg-[#0D0F12] text-slate-100 min-h-screen font-body" data-testid="public-site">
      <Header contact={content.contact} onQuote={() => scrollToEnquiry()} products={content.products} />
      <main>
        <Hero hero={content.hero} stats={content.stats} contact={content.contact} onQuote={() => scrollToEnquiry()} />
        <Products products={content.products} onQuote={scrollToEnquiry} />
        <Capabilities capabilities={content.capabilities} hero={content.hero} />
        <WhyUs items={content.why_us} />
        <About about={content.about} />
        <Gallery items={content.gallery} />
        <Testimonials items={content.testimonials} />
        <EnquiryForm products={content.products} contact={content.contact} productInterest={productInterest} />
      </main>
      <Footer contact={content.contact} products={content.products} />
      <FloatingCTA contact={content.contact} />
    </div>
  );
}
